import { render, staticRenderFns } from "./DisplayEmpty.vue?vue&type=template&id=60e74a9f&scoped=true&"
import script from "./DisplayEmpty.vue?vue&type=script&lang=js&"
export * from "./DisplayEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e74a9f",
  null
  
)

export default component.exports